__webpack_require__.p = "https://click11frnt.hurry2.net/templates/clickbet/";